<div class="main-layout">
  <app-header class="header-component" *ngIf="headerEnable"></app-header>
  <div class="margin-all-site">
    <router-outlet></router-outlet>
  </div>
  <app-footer *ngIf="headerEnable"></app-footer>
</div>
<p-confirmDialog [style]="{width: '50vw'}" key="positionDialog" [baseZIndex]="10000"></p-confirmDialog>
<p-toast></p-toast>
<p-dialog [(visible)]="_AuthService.isLoginDialog" class="global-login-dialog" [showHeader]="false"
  [style]="{width: '100%' ,maxWidth: '555px'}" [modal]="true">
  <span class="custom-close pi pi-times" (click)="_AuthService.isLoginDialog=false"></span>
  <p class="no-login-payment-title">Login to continue</p>
  <button class="no-login-btn" (click)="login()"><span>Login Now</span></button>
</p-dialog>